module.exports =
  '_LEGAL':
    'TITLE': 'Legal Information'




// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/legal/i18n/en.coffee